// Components==============
import TokenGetter from 'components/UI/TokenGetter/TokenGetter';
import { motion } from 'framer-motion';
import { useSliderValue } from 'hooks/useSliderValue';
import { useTranslate } from 'hooks/useTranslate';
import React, { useRef } from 'react';
import './Card.module.scss';
// =========================

const card = {
  hover: {
    opacity: 1,
    pointerEvents: 'all' as 'all',
  },
  initial: {
    opacity: 0,
    pointerEvents: 'none' as 'none',
  },
};

export default function Card({ reflection }: { reflection: ReflectionEntity }) {
  const translate = useTranslate();

  const sliderValue = useSliderValue(reflection.result);

  const spanRef = useRef<HTMLSpanElement>(null);

  return (
    <motion.div styleName="wrapper" variants={card}>
      {!!reflection?.project_process && (
        <TokenGetter activity={reflection?.project_process} />
      )}
      {!!reflection?.emotions.length && (
        <>
          <p>{translate('reflection.terms.experience')}</p>
          <div
            styleName="emotions"
            style={{
              gridTemplateColumns:
                reflection.emotions.length > 3
                  ? 'repeat(4, 1fr)'
                  : `repeat(${reflection.emotions.length}, 1fr)`,
            }}
          >
            {reflection?.emotions.map((emotion) => (
              <img
                key={emotion.id}
                src={emotion.thumbnail}
                alt={emotion.name}
              />
            ))}
          </div>
        </>
      )}
      {!!reflection?.result && (
        <>
          <p>{translate('general.terms.result')}</p>
          <div styleName="slider">
            <div styleName="outside">
              <div
                styleName="inside"
                style={{ width: `${(100 / 8) * reflection.result}%` }}
              />
            </div>
            <span
              ref={spanRef}
              style={{
                left:
                  reflection.result === 1 || reflection.result === 8
                    ? ''
                    : `calc(${(100 / 8) * reflection.result}% - ${
                        (spanRef.current?.clientWidth || 20) / 2
                      }px)`,
                right: reflection.result === 8 ? 0 : '',
              }}
            >
              {sliderValue}
            </span>
          </div>
        </>
      )}
    </motion.div>
  );
}
